import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'

export function createAdminPathAliases(
  config: ResolvedBetterstartConfig
): Record<string, string[]> {
  const namespace = resolveAdminNamespace(config.frameworkConfig.next.namespace)
  const adminPath = config.paths.admin

  return {
    [`${namespace.alias}/*`]: [`${adminPath}/*`],
    [`${namespace.alias}/db`]: [`${adminPath}/lib/db/client`],
    [`${namespace.alias}/db/schema`]: [`${adminPath}/lib/db/schema`],
    [`${namespace.alias}/actions/*`]: [`${adminPath}/lib/actions/*`],
    [`${namespace.alias}/auth/server`]: [`${adminPath}/lib/actions/auth/server`],
    [`${namespace.alias}/auth/client`]: [`${adminPath}/lib/actions/auth/client`],
    [`${namespace.alias}/auth/session`]: [`${adminPath}/lib/actions/auth/session`],
    [`${namespace.alias}/hooks/*`]: [`${adminPath}/hooks/*`],
    [`${namespace.alias}/components/*`]: [`${adminPath}/components/*`],
    [`${namespace.alias}/types`]: [`${adminPath}/types`],
    [`${namespace.alias}/types/*`]: [`${adminPath}/types/*`],
    [`${namespace.alias}/utils/*`]: [`${adminPath}/utils/*`]
  }
}
